export const transactionurl = {
    bsc: 'https://bscscan.com/tx/',
    eth: 'https://etherscan.io/tx/',
    trx: 'https://tronscan.org/#/transaction/',
    POL: "https://polygonscan.com/tx/",
    SOL: "https://explorer.solana.com/tx/",
}
export const transactionurlAddress = {
    bsc: 'https://testnet.bscscan.com/address/',
}

export const solUrl = (hash) => "https://solscan.io/tx/" + hash



